import { type ReactNode, useState } from "react";

import { Sidebar } from "../Sidebar/Sidebar";
import { useSidebarNavigation } from "../Sidebar/useSidebarNavigation";
import { Topbar } from "../Topbar/Topbar";

import styles from "./PageLayout.module.css";

interface Props {
  children: ReactNode;
  /** Desactiva el gutter por defecto del contenido para vistas edge-to-edge (p. ej. el mapa de Home). */
  fullBleed?: boolean;
}

export const PageLayout = ({ children, fullBleed = false }: Props) => {
  const {
    onHomeClick,
    onPlantsClick,
    onDocumentationClick,
    onAlertsClick,
    onLogoutClick,
    onFeedbackClick,
  } = useSidebarNavigation();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    () => localStorage.getItem("sidebar_collapsed") === "true",
  );

  const handleToggle = (collapsed: boolean) => {
    setIsSidebarCollapsed(collapsed);
    localStorage.setItem("sidebar_collapsed", String(collapsed));
  };

  return (
    <div
      className={`${styles.root} ${isSidebarCollapsed ? styles.sidebarCollapsed : ""}`}
    >
      <Sidebar
        onHomeClick={onHomeClick}
        onPlantsClick={onPlantsClick}
        onDocumentationClick={onDocumentationClick}
        onAlertsClick={onAlertsClick}
        onLogoutClick={onLogoutClick}
        onFeedbackClick={onFeedbackClick}
        isCollapsed={isSidebarCollapsed}
      />
      <div className={styles.main}>
        <Topbar
          isCollapsed={isSidebarCollapsed}
          onToggleCollapse={() => handleToggle(!isSidebarCollapsed)}
        />
        <main
          className={`${styles.content} ${fullBleed ? styles.fullBleed : ""}`}
        >
          {children}
        </main>
      </div>
    </div>
  );
};
